import React from 'react';
import PropTypes from 'prop-types';
import { ModalService, AccountService } from '@sm360/widget-commons-general';

import GuestSection from 'login/components/GuestOrSignin/components/GuestSection/GuestSection.jsx';
import SigninSection from 'login/components/GuestOrSignin/components/SignInSection/SigninSection.jsx';

import { SIGN_UP, LOGIN } from 'login/constants/modalNames.js';

class GuestOrSignin extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.signupModal = ModalService.get(SIGN_UP);
        this.signinModal = ModalService.get(LOGIN);
        this.onGuestSelection = this.onGuestSelection.bind(this);
        this.onAuthenticationClose = this.onAuthenticationClose.bind(this);
    }

    componentDidMount() {
        this.signupModal.addCallbacks({
            onClose: this.onAuthenticationClose,
        });

        this.signinModal.addCallbacks({
            onClose: this.onAuthenticationClose,
        });
    }

    componentWillUnmount() {
        this.signupModal.removeCallbacks({
            onClose: this.onAuthenticationClose,
        });

        this.signinModal.removeCallbacks({
            onClose: this.onAuthenticationClose,
        });
    }

    onGuestSelection(selectedOption) {
        if (selectedOption === 'signup') {
            this.signupModal.open();
            return;
        }

        this.props.onSuccess(true);
    }

    onAuthenticationClose() {
        if (AccountService.isAuthenticated()) {
            this.props.onSuccess(false);
        }
        return true;
    }

    render() {
        return (
            <div>
                <GuestSection onSelection={this.onGuestSelection} />
                <SigninSection onLogin={this.onAuthenticationClose} />
            </div>
        );
    }
}

GuestOrSignin.propTypes = {
    onSuccess: PropTypes.func.isRequired,
};

GuestOrSignin.displayName = 'GuestOrSignin';

export default GuestOrSignin;
